export default {
  props: {
    propBus: {
      type: Object,
    },
  },
  computed: {
    footer() {
      return {
        ...this.$t('components.footer'),
      }
    },

    isEnglish() {
      let language = this.$i18n.locale

      return language === 'en' ? true : false
    },
  },
}
